import { css } from '@emotion/react';
import React from 'react';
import { breakpoints, spacing } from '../../../../utils/styleguide';
import { ImageStyleProps } from '../../../contentful-elements/Image';
import PropsComponent from '../../types/PropsComponent';
import { Variant } from '../../types/VariantTypes';
import styled from '@emotion/styled';

const LogoBlock = styled.div`
  margin-top: ${spacing[4]}px;
  display: flex;

  ${breakpoints.tablet} {
    margin-top: ${spacing[6]}px;
  }
`;

type LogosProps = { logos: Logo[]; variant?: Variant };

export const Logos = ({ logos, variant = 'light' }: LogosProps) => {
  if (!logos || !logos.length) {
    return null;
  }

  return (
    <LogoBlock>
      {logos.map((logo, index) => (
        <Logo key={index} logo={logo} variant={variant} />
      ))}
    </LogoBlock>
  );
};

export type Logo = {
  title: string;
  Image: PropsComponent<ImageStyleProps>;
};

type LogoProps = {
  logo: Logo;
  variant?: Variant;
};

const Logo = ({ logo, variant = 'light' }: LogoProps) => {
  const Image = logo.Image;

  return (
    <Image
      wrapperCss={css`
        filter: brightness(0) ${variant === 'light' ? 'invert(1)' : ''}; // colors.white independant of image color
        margin-right: ${spacing[4]}px;
        height: 20px;

        ${breakpoints.tablet} {
          margin-right: ${spacing[6]}px;
          height: 24px;
        }
      `}
      css={css`
        height: 100%;
        max-width: 100%;
        object-fit: contain;
      `}
      key={logo.title}
    />
  );
};
